// @flow

import * as React from 'react';

type Props = {
  onMouseDown: (MouseEvent) => void,
};

const Resize = ({onMouseDown}: Props): React.Node => (
  <div className="StripeCluiResize" onMouseDown={onMouseDown} role="button">
    <div className="StripeCluiResize-notch" />
  </div>
);

export default Resize;
